import React, { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { NAME_SPACE } from 'i18n';
import { UserContext, ROLES } from 'auth';
import { PageHeader, ViewTable, Toolbar, ButtonExport } from 'shared';

import { useOrdersPaginated } from './useOrdersPaginated';
import { useOrdersBuildTable } from './useOrdersBuildTable';

export function ListOrders() {
  const { orders, getOrders, exportItems, isExporting } = useOrdersPaginated();
  const { t } = useTranslation(NAME_SPACE.ORDERS);
  const { rows, headCells, exportHeadCells } = useOrdersBuildTable(orders, t);
  const { hasRole } = useContext(UserContext);
  const hasAdminRole = useMemo(() => hasRole([ROLES.ADMIN]), [hasRole]);

  return (
    <>
      <PageHeader>
        {t('name')}
        <Toolbar>
          {hasAdminRole && <ButtonExport onClick={() => exportItems(exportHeadCells)} disabled={isExporting} />}
        </Toolbar>
      </PageHeader>

      <ViewTable
        rows={rows}
        cells={headCells}
        defaultOrderBy={{ property: 'entryDate', direction: 'desc' }}
        onFetchData={getOrders}
        totalRows={orders?.total}
        allowRowSelection={false}
        serverSidePaging
      />
    </>
  );
}
